<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-03 10:14:51
 * @LastEditTime: 2019-09-05 17:57:01
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    class="selfModal selfModal_youBtn"
    title="选择默认首页"
    :close-on-click-modal="false"
    :before-close="handleDialogClose"
    :visible.sync="defaultPageDialog"
    :modal="false"
    width="500px"
  >
    <div class="defaultPage_wrapper">
      <el-scrollbar style="height:100%">
        <el-tree
          highlight-current
          default-expand-all
          :key="treeKey"
          ref="radioMenuTree"
          id="taskTreeL"
          :check-strictly="true"
          :show-checkbox="true"
          :default-checked-keys="defaultCheckedArray"
          node-key="expandId"
          :data="radioUserMenus"
          :props="defaultStaticProps"
          :default-expanded-keys="defaultExpandedKeys"
          @node-click="handleStaticNodeClick"
          @check-change="handleCheckChange"
        >
          <span class="span-ellipsis" slot-scope="{ node }">
            <span :title="node.label">{{ node.label }}</span>
          </span>
        </el-tree>
      </el-scrollbar>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit()">确 认</el-button>
      <el-button @click="handleDialogClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addRole } from "@/api/system/role";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "selectDefaultPage",
  data() {
    return {
      defaultStaticProps: {
        children: "children",
        label: "name" || "label"
      },
      defaultExpandedKeys: [],
      defaultCheckedArray: [],
      checkedId: "",
      checkedName: "",
      treeKey: Date.parse(new Date())
    };
  },
  components: {},
  computed: {
    ...mapGetters(["defaultPageDialog", "userMenus", "roleFormData"]),
    radioUserMenus() {
      const radioUserMenus = JSON.parse(JSON.stringify(this.userMenus));
      return radioUserMenus;
    }
  },
  watch: {
    defaultPageDialog(val) {
      this.defaultExpandedKeys = [];
      if (!val) {
        this.checkedId = "";
        this.checkedName = "";
        this.$refs.radioMenuTree.setCheckedKeys([]);
      } else {
        this.treeKey = Date.parse(new Date());
        this.checkedId = this.roleFormData.defaultPageId;
        this.checkedName = this.roleFormData.defaultPageId;
        this.$nextTick(() => {
          this.radioUserMenus.forEach((item, index) => {
            if (item.children.length > 0) {
              item.children.forEach((value, key) => {
                if (value.id == this.roleFormData.defaultPageId) {
                  this.defaultExpandedKeys = [].concat([item.id]);
                  return;
                }
              });
            }
          });
          this.$refs.radioMenuTree.setCheckedKeys([
            this.roleFormData.defaultPageId
          ]);
        });
      }
    },
    radioUserMenus: {
      handler(newVal, oldVal) {
        this.generateStaticTree(newVal);
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  methods: {
    ...mapMutations({
      setDefaultPageDialog: "setDefaultPageDialog",
      setDefaultPage: "setDefaultPage"
    }),
    handleDialogClose() {
      this.setDefaultPageDialog(false);
    },
    handleStaticNodeClick(data) {
      // console.log("--静态树点击节点data--", data);
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked === true) {
        this.checkedId = data.id;
        this.checkedName = data.name;
        this.$refs.radioMenuTree.setCheckedKeys([data.id]);
      } else {
        if (this.checkedId == data.id) {
          this.$refs.radioMenuTree.setCheckedKeys([data.id]);
        }
      }
    },
    generateStaticTree(source) {
      if (source && source.length > 0) {
        const filterFun = target => {
          target.forEach(item => {
            let nodeIsLeaf = item.hasChildren ? true : false;
            item.label = item.name;
            item.expandId = item.id;
            item.isLeaf = nodeIsLeaf;
            item.popoverId = "popover" + item.id;
            item.popoverVisible = false;
            if (item.hasChildren) {
              item.disabled = true;
            }
            if (
              item.level === 1 &&
              !this.defaultExpandedKeys.includes(item.expandId)
            ) {
              this.defaultExpandedKeys.push(item.expandId);
            }
            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };
        filterFun(source);
        this.$nextTick(function() {
        });
      } else {
        return;
      }
    },
    // 提交表单
    submit() {
      this.setDefaultPage({ name: this.checkedName, id: this.checkedId });
    }
  }
};
</script>
<style lang="less">
.defaultPage_dialog{
  .el-dialog .el-dialog__body {
    max-height: calc(100vh - 282px) !important;
    overflow: auto;
  }
}
.defaultPage_wrapper {
  .el-checkbox__input {
    margin-right: 8px;
  }
}
</style>
